import "./Ingredients.css";
import ingredientsImg from "./../../assets/2.png";

const Ingredients = () => {
  return (
    <div className="ingredients">
      <div className="container">
        <div className="row">
          <div className="col-md-6 ">
            <h2>
              We make everything by hand with the best possible ingredients.
            </h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et
              purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat
              tellus.Far far away, behind the word mountains, far from the
              countries Vokalia and Consonantia, there live the blind texts.
            </p>
            <ul>
              <li>Etiam sed dolor ac diam volutpat.</li>
              <li>Etiam sed dolor ac diam volutpat.</li>
              <li>Etiam sed dolor ac diam volutpat.</li>
            </ul>
            <button>learn more</button>
          </div>
          <div className="col-md-6">
            <img src={ingredientsImg} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ingredients;
